import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import MakesDifferentImg2 from '../assets/images/about-us/img-1.png';
import MakesDifferentImg3 from '../assets/images/home-real-estate-agent-form-img.png';
import MakesDifferentImg4 from '../assets/images/about-us/img-5.png';
import MakesDifferentImg5 from '../assets/images/about-us/img-6.png';
import MakesDifferentImg6 from '../assets/images/about-us/img-7.png';
import MakesDifferentImg7 from '../assets/images/about-us/img-8.png';


const makesDifferentSlides = [
  MakesDifferentImg2,
  MakesDifferentImg3,
  MakesDifferentImg4,
  MakesDifferentImg5,
  MakesDifferentImg6,
  MakesDifferentImg7
];

const MakesDifferent = () => {
  return (
    <section className="makes-different">
      <Container>
        <Row className="align-items-center">
          {/* Left Content */}
          <Col lg={6} md={12}>
            <div className="makes-different-content">
              <h2 className="makes-different-title">
                What Makes<br/>
                <span className="red">JamboBay</span> Different
              </h2>
              <p className="makes-different-description">
                At JamboBay, we combine local market expertise with modern technology to simplify every stage of the property journey. Whether you're purchasing your first home, investing in commercial property, or searching for premium land, our experienced team is committed to delivering personalized guidance tailored to your goals.
              </p>
              <p className="makes-different-description">
                We prioritize transparency, trust, and long-term relationships. Every property we recommend is carefully evaluated to ensure quality, legal compliance, and investment potential. From consultation to final possession, we remain by your side, making the entire experience smooth, stress-free, and rewarding.
              </p>
            </div>
          </Col>
          {/* Right Image */}
          <Col lg={6} md={12}>
            <div className="makes-different-image">
              <Swiper
                modules={[Autoplay]}
                loop
                autoplay={{
                  delay: 2500,
                  disableOnInteraction: false,
                }}
                className="br-tl-br"
              >
                {makesDifferentSlides.map((slide, index) => (
                  <SwiperSlide key={index}>
                    <img src={slide} alt="Modern House" />
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default MakesDifferent;
